import { Component, input, OnChanges, output, signal, SimpleChanges, TemplateRef, viewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpService } from 'app/services/http.service';

@Component({
    selector: 'app-invalidate-walt-credentials-modal',
    templateUrl: './invalidate-walt-credentials-modal.component.html',
    styleUrls: ['./invalidate-walt-credentials-modal.component.scss'],
})
export class InvalidateWaltCredentialsModalComponent implements OnChanges {
    readonly open = input.required<boolean>();
    readonly waltId = input<string>();
    readonly loadingChanged = output<boolean>();
    readonly submitEvent = output();
    readonly closeEvent = output();
    readonly errorEvent = output<any>();

    private dialogRef: MatDialogRef<unknown>;
    readonly isSubmitting = signal(false);
    readonly modalContent = viewChild<TemplateRef<unknown>>('modalContent');
    enteredWaltId = '';

    constructor(
        private readonly _dialog: MatDialog,
        private readonly _snackBar: MatSnackBar,
        private readonly _httpService: HttpService,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if ('open' in changes) {
            if (this.open()) {
                this.openDialog();
            } else {
                this.closeDialog();
            }
        }
    }

    closeDialog() {
        this.enteredWaltId = '';
        this.dialogRef?.close();
        this.closeEvent.emit();
    }

    private openDialog() {
        this.enteredWaltId = '';
        this.dialogRef = this._dialog.open(this.modalContent(), { id: 'enable-disable-wifi' });
        this.dialogRef.backdropClick().subscribe(() => this.closeDialog());
    }

    async dialogSubmit() {
        this.loadingChanged.emit(true);
        this.isSubmitting.set(true);
        try {
            const invalidateWaltCredentialsRequest = {
                waltId: this.waltId()?.toString(),
            };
            await this._httpService.post('administration/invalidate-walt-credentials', invalidateWaltCredentialsRequest);
            this._snackBar.open('Walt credentials invalidated successfully', 'Close', { duration: 5000 });
            this.submitEvent.emit();
            this.closeDialog();
        } catch (error) {
            this.errorEvent.emit(error);
            this._snackBar.open(`Failed to invalidate walt credential: ${error.message}`, 'Dismiss', { duration: 10_000 });
        } finally {
            this.loadingChanged.emit(false);
            this.isSubmitting.set(false);
            this.closeDialog();
        }
    }
}
